import * as ACTION from './actionTypes';
import { callAccedoAPI } from "../../axios/accedoApi";
import {callAPI} from "../../axios/index"

const getBluetoothDevicesRequest = () => {
    return {
        type: ACTION.GET_BLUETOOTH_DEVICES_REQUEST
    }
}

const getBluetoothDevicesSuccess = (apiData) => {
    return {
        type: ACTION.GET_BLUETOOTH_DEVICES_SUCCESS,
        payload: apiData,
    }
}

const getBluetoothDevicesFailure = (errorMsg) => {
    return {
        type: ACTION.GET_BLUETOOTH_DEVICES_FAILURE,
        payload: errorMsg,
    }
}

export const bluetoothDevicesFetchNowControlTimerFlag = () => {
    return {
        type: ACTION.BLUETOOTH_DEVICES_FETCH_NOW_CONTROL_TIMER_FLAG,
        // payload: payload,
    }
}

const bluetoothDevicesFetchNowControl = (payload)=>{
    return {
        type: ACTION.BLUETOOTH_DEVICES_FETCH_NOW_CONTROL,
        payload: payload,
    }
}

export const bluetoothDevicesFetchNowStatus = (payload) => {
    return {
        type: ACTION.BLUETOOTH_DEVICES_FETCH_NOW_STATUS,
        payload: payload,
    }
}

export const bluetoothDevicesProcessedWebhookTriggered = (payload) => {
    return {
        type: ACTION.BLUETOOTH_DEVICES_PROCESSED_WEBHOOK_TRIGGERED,
        payload: payload,
    }
}

export const getBluetoothDevicesData = (sid,cdsn) => {
    const apiPath = `/KPI/STB/bluetoothDevices/${sid}/${cdsn}`;
    return async function(dispatch) {
        dispatch(getBluetoothDevicesRequest());
        callAccedoAPI(`${localStorage.getItem("accedo_url")}${apiPath}`,"GET").then(res => {
            dispatch(getBluetoothDevicesSuccess(res));
        })
        .catch(err => {
            dispatch(getBluetoothDevicesFailure(err.message));
        });;
    };
};

export const postFetchNowBluetoothDevicesControl = (sid,cdsn,payload, controlAction) => {
    const controlApiPath = `/control/${cdsn}/${controlAction}`;
    let statusApiPath = `/control/status/${sid}?by=CRID&id=`
    return async function(dispatch) {
        callAccedoAPI(`${localStorage.getItem("accedo_url")}${controlApiPath}`,"POST", payload).then(res => {
            localStorage.setItem(`FetchNowBluetoothDevicesSid-${sid}Cdsn-${cdsn}InitiateTime`,new Date().getTime())
            dispatch(bluetoothDevicesFetchNowControl(res));
            callAPI("/control","POST",{
                controlRequestID: res.body.controlRequestID,
                action: res.body.action,
                sid: sid,
                cdsn: cdsn,
              })
            callAccedoAPI(`${localStorage.getItem("accedo_url")}${statusApiPath}${res.body.controlRequestID}`,"GET").then(response => {
                // console.log(response[0])
                dispatch(bluetoothDevicesFetchNowStatus(response[0]));
            })
            // setTimeout(()=>{
            //     dispatch(bluetoothDevicesFetchNowControlTimerFlag())
            //   },120000)
        })
        .catch(err => {
            dispatch(getBluetoothDevicesFailure(err.message));
        });
    }; 
};